/**
 * Dyou → Razorpay cart-recovery (theme-only).
 * POSTs checkout.abandoned with HMAC-SHA256 headers.
 * Signing key is intentionally in the storefront (theme-only constraint).
 */
(function () {
  var CFG = window.__DYOU_RZ_CART_RECOVERY__;
  if (!CFG || !CFG.enabled || !CFG.connectionId || !CFG.signingKey) return;

  var ENDPOINT =
    "https://api.razorpay.com/v1/connectors/" +
    encodeURIComponent(CFG.connectionId) +
    "/events";
  var SENT_PREFIX = "dyou_rz_abandon_sent_";
  var IDEM_PREFIX = "dyou_rz_abandon_idem_";
  var CHECKOUT_INTENT_KEY = "dyou_rz_checkout_intent";
  var sending = false;

  function utf8Bytes(str) {
    return new TextEncoder().encode(str);
  }

  function bytesToHex(buf) {
    return Array.from(new Uint8Array(buf))
      .map(function (b) {
        return b.toString(16).padStart(2, "0");
      })
      .join("");
  }

  function hmacSha256Hex(secret, message) {
    return crypto.subtle
      .importKey(
        "raw",
        utf8Bytes(secret),
        { name: "HMAC", hash: "SHA-256" },
        false,
        ["sign"]
      )
      .then(function (key) {
        return crypto.subtle.sign("HMAC", key, utf8Bytes(message));
      })
      .then(bytesToHex);
  }

  function idempotencyKeyForCart(token) {
    var k = IDEM_PREFIX + token;
    var existing = sessionStorage.getItem(k);
    if (existing) return existing;
    var id =
      typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0;
            var v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          });
    sessionStorage.setItem(k, id);
    return id;
  }

  function alreadySent(token) {
    return sessionStorage.getItem(SENT_PREFIX + token) === "1";
  }

  function markSent(token) {
    sessionStorage.setItem(SENT_PREFIX + token, "1");
  }

  function normalizePhone(phone) {
    if (!phone || typeof phone !== "string") return "";
    var cleaned = phone.replace(/[^\d+]/g, "");
    if (!cleaned) return "";
    if (cleaned.charAt(0) !== "+") {
      if (cleaned.length === 10) cleaned = "+91" + cleaned;
      else if (cleaned.indexOf("91") === 0 && cleaned.length === 12)
        cleaned = "+" + cleaned;
    }
    return cleaned;
  }

  function resolvePhone(cart) {
    var fromCfg = normalizePhone(CFG.customerPhone || "");
    if (fromCfg) return fromCfg;

    try {
      var attrs = (cart && cart.attributes) || {};
      var candidates = [
        attrs.phone,
        attrs.Phone,
        attrs.customer_phone,
        attrs["customer-phone"],
      ];
      for (var i = 0; i < candidates.length; i++) {
        var n = normalizePhone(String(candidates[i] || ""));
        if (n) return n;
      }
    } catch (e) {}

    try {
      var stored = normalizePhone(
        localStorage.getItem("shopflo_phone") ||
          localStorage.getItem("customer_phone") ||
          ""
      );
      if (stored) return stored;
    } catch (e2) {}

    return "";
  }

  function buildResumeLink(cart) {
    if (CFG.shopfloResumeUrl) return CFG.shopfloResumeUrl;
    try {
      if (window.Shopflo && typeof window.Shopflo.getCheckoutUrl === "function") {
        var u = window.Shopflo.getCheckoutUrl();
        if (u) return u;
      }
    } catch (e) {}

    var parts = (cart.items || []).map(function (item) {
      return item.variant_id + ":" + item.quantity;
    });
    if (!parts.length) return CFG.shopOrigin + "/cart";
    return CFG.shopOrigin + "/cart/" + parts.join(",");
  }

  function firstLine(cart) {
    return (cart.items && cart.items[0]) || null;
  }

  function buildPayload(cart, phone) {
    var line = firstLine(cart);
    var variantId = line ? String(line.variant_id) : "";
    var sku = (line && line.sku) || "";
    var referenceId = (sku || "NOSKU") + "|" + variantId;
    var productName = line ? line.product_title || line.title || "" : "";
    var productUrl = ".";
    if (line && line.url) {
      productUrl =
        line.url.indexOf("http") === 0 ? line.url : CFG.shopOrigin + line.url;
    }

    return {
      source: "business.connector",
      event: "checkout.abandoned",
      payload: {
        reference_id: referenceId,
        order_id: String(cart.token || ""),
        customer_name: CFG.customerName || "",
        customer_phone: phone,
        amount: Number(cart.total_price) || 0,
        resume_link: buildResumeLink(cart),
        payment_link: "",
        product_name: productName,
        product_url: productUrl,
        abandoned_stage: "cart",
      },
    };
  }

  function fetchCart() {
    var root =
      (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return fetch(root + "cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }).then(function (r) {
      if (!r.ok) throw new Error("cart.js " + r.status);
      return r.json();
    });
  }

  function postEvent(bodyObj, cartToken) {
    var rawBody = JSON.stringify(bodyObj);
    var timestamp = String(Math.floor(Date.now() / 1000));
    var idem = idempotencyKeyForCart(cartToken);

    return hmacSha256Hex(CFG.signingKey, timestamp + "." + rawBody).then(
      function (signature) {
        return fetch(ENDPOINT, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Idempotency-Key": idem,
            "X-Event-Timestamp": timestamp,
            "X-Event-Signature": signature,
          },
          body: rawBody,
          mode: "cors",
          keepalive: true,
        }).then(function (res) {
          return res.text().then(function (text) {
            var parsed = null;
            try {
              parsed = text ? JSON.parse(text) : null;
            } catch (e) {}
            return { status: res.status, body: parsed || text };
          });
        });
      }
    );
  }

  function maybeSendAbandoned(reason) {
    if (sending) return Promise.resolve({ skipped: "in_flight" });
    sending = true;

    return fetchCart()
      .then(function (cart) {
        if (!cart || !cart.item_count) {
          return { skipped: "empty_cart" };
        }
        var token = String(cart.token || "");
        if (!token) return { skipped: "no_token" };
        if (alreadySent(token)) return { skipped: "already_sent" };

        var phone = resolvePhone(cart);
        if (!phone) {
          if (CFG.debug) {
            console.info("[dyou-rz] skip abandon: no phone", reason);
          }
          return { skipped: "no_phone" };
        }

        var body = buildPayload(cart, phone);
        return postEvent(body, token).then(function (result) {
          if (result.status === 202) {
            markSent(token);
          }
          if (CFG.debug || result.status !== 202) {
            console.info("[dyou-rz] abandon push", reason, result);
          }
          return result;
        });
      })
      .catch(function (err) {
        console.warn("[dyou-rz] abandon push failed", reason, err);
        return { error: String(err && err.message ? err.message : err) };
      })
      .finally(function () {
        sending = false;
      });
  }

  function markCheckoutIntent() {
    try {
      sessionStorage.setItem(CHECKOUT_INTENT_KEY, String(Date.now()));
    } catch (e) {}
  }

  function hadRecentCheckoutIntent() {
    try {
      var t = Number(sessionStorage.getItem(CHECKOUT_INTENT_KEY) || 0);
      return t && Date.now() - t < 30 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  function onAbandonSignal(reason) {
    if (!hadRecentCheckoutIntent() && reason !== "manual") return;
    maybeSendAbandoned(reason);
  }

  document.addEventListener(
    "click",
    function (e) {
      var el =
        e.target && e.target.closest
          ? e.target.closest(
              "#checkout2, #checkout3, .cart__checkout-button, [name='checkout2'], [name='checkout3']"
            )
          : null;
      if (el) markCheckoutIntent();
    },
    true
  );

  var originalFlo =
    typeof window.handleFloCheckoutBtn === "function"
      ? window.handleFloCheckoutBtn
      : null;
  window.handleFloCheckoutBtn = function () {
    markCheckoutIntent();
    if (originalFlo) return originalFlo.apply(this, arguments);
  };

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
      onAbandonSignal("visibilitychange");
    }
  });

  window.addEventListener("pagehide", function () {
    onAbandonSignal("pagehide");
  });

  // Expose for shadow-mode / manual tests from DevTools
  window.dyouRazorpayCartRecovery = {
    sendNow: function () {
      markCheckoutIntent();
      return maybeSendAbandoned("manual");
    },
  };
})();
